import { getStorefrontIdentity } from "../config/storefrontRuntime";

function randomId(prefix) {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return `${prefix}_${crypto.randomUUID()}`;
  }
  return `${prefix}_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 12)}`;
}

function namespace() {
  const identity = getStorefrontIdentity();
  return identity.projectKey || identity.storefrontHost || "storefront";
}

function key(name) {
  return `webprofit:${namespace()}:${name}:v2`;
}

function storageId(storage, storageKey, prefix) {
  if (typeof window === "undefined") return randomId(prefix);
  try {
    const current = storage.getItem(storageKey);
    if (current) return current;
    const created = randomId(prefix);
    storage.setItem(storageKey, created);
    return created;
  } catch {
    return randomId(prefix);
  }
}

export function getStorefrontActivityIdentity() {
  if (typeof window === "undefined") {
    return { visitorId: "", sessionId: "", tabId: "", step: 0 };
  }
  const visitorId = storageId(window.localStorage, key("visitor-id"), "visitor");
  const sessionId = storageId(window.sessionStorage, key("session-id"), "session");
  const tabId = storageId(window.sessionStorage, key("tab-id"), "tab");
  let step = 0;
  try {
    step = Math.max(0, Number(window.sessionStorage.getItem(key("journey-step")) || 0));
  } catch {
    step = 0;
  }
  return { visitorId, sessionId, tabId, step };
}

export function nextStorefrontJourneyStep() {
  const identity = getStorefrontActivityIdentity();
  const step = identity.step + 1;
  try {
    window.sessionStorage.setItem(key("journey-step"), String(step));
  } catch {
    // La identidad sigue funcionando aunque el navegador bloquee storage.
  }
  return { ...identity, step };
}

export function getPreviousStorefrontPath() {
  if (typeof window === "undefined") return "";
  try {
    return window.sessionStorage.getItem(key("current-path")) || "";
  } catch {
    return "";
  }
}

export function setCurrentStorefrontPath(path) {
  if (typeof window === "undefined") return;
  try {
    window.sessionStorage.setItem(key("current-path"), String(path || ""));
  } catch {
    // No interrumpir la navegación por restricciones de storage.
  }
}

export function getStorefrontActivityHeaders() {
  const { visitorId, sessionId, tabId } = getStorefrontActivityIdentity();
  return {
    "x-webprofit-visitor-id": visitorId,
    "x-webprofit-session-id": sessionId,
    "x-webprofit-tab-id": tabId,
  };
}
